import { defineComponent, ref } from "vue";
import InputText from "../forms/InputText";
import InputSelect from "../forms/InputSelect";
import Utils from "../utils/Utils";
import * as moment from "moment";
import InputDate from "../forms/InputDate";

export default defineComponent({
    components: {
        InputText,
        InputDate,
        InputSelect,
    },

    template: `
        <div class="LabeledInput">
            <div class="LabeledInput__label">
                <span>{{ label }}</span>

                <button v-if="tip" type="button" class="LabeledInput__tip">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_13282_29477)">
                            <path d="M7.22656 11.9003C7.22656 12.327 7.57323 12.6736 7.9999 12.6736C8.42656 12.6736 8.77323 12.327 8.77323 11.9003C8.77323 11.4736 8.42656 11.127 7.9999 11.127C7.57323 11.127 7.22656 11.4736 7.22656 11.9003ZM8.29323 11.9003C8.29323 12.0603 8.1599 12.1936 7.9999 12.1936C7.8399 12.1936 7.70656 12.0603 7.70656 11.9003C7.70656 11.7403 7.8399 11.607 7.9999 11.607C8.1599 11.607 8.29323 11.7403 8.29323 11.9003Z" fill="#005537"/>
                            <path d="M13.0271 3.56711C12.7938 3.74711 12.7471 4.08044 12.9204 4.31378C13.7271 5.38044 14.1471 6.66044 14.1471 8.00044C14.1471 11.3871 11.3871 14.1471 8.00044 14.1471C4.61378 14.1471 1.85378 11.3871 1.85378 8.00044C1.85378 4.61378 4.61378 1.85378 8.00044 1.85378C9.23378 1.85378 10.4204 2.21378 11.4338 2.90044C11.6804 3.06711 12.0071 3.00044 12.1738 2.76044C12.3404 2.51378 12.2738 2.18711 12.0271 2.02044C10.8338 1.21378 9.44044 0.787109 7.99378 0.787109C4.02044 0.787109 0.787109 4.02044 0.787109 8.00044C0.787109 11.9804 4.02044 15.2138 8.00044 15.2138C11.9804 15.2138 15.2138 11.9804 15.2138 8.00044C15.2138 6.42711 14.7138 4.92711 13.7738 3.67378C13.5938 3.44044 13.2604 3.39378 13.0271 3.56711Z" fill="#005537"/>
                            <path d="M9.77316 7.52703C10.2465 7.0537 10.5065 6.42036 10.5065 5.7137C10.5065 4.32703 9.37983 3.20703 7.99983 3.20703C6.61983 3.20703 5.49316 4.3337 5.49316 5.7137C5.49316 6.00703 5.73316 6.24703 6.0265 6.24703C6.31983 6.24703 6.55983 6.00703 6.55983 5.7137C6.55983 4.92036 7.2065 4.26703 7.99983 4.26703C8.79316 4.26703 9.43983 4.9137 9.43983 5.7537C9.43983 6.14036 9.2865 6.50036 9.01983 6.7737L8.5465 7.24703C7.85316 7.94036 7.47316 8.86036 7.47316 9.84036C7.47316 10.1337 7.71316 10.3737 8.0065 10.3737C8.29983 10.3737 8.53983 10.1337 8.53983 9.84036C8.53983 9.14703 8.81316 8.4937 9.29983 8.00036L9.77316 7.52703Z" fill="#005537"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_13282_29477">
                            <rect width="16" height="16" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>

            <div class="LabeledInput__widget">
                <template v-if="!edit">
                    <div class="LabeledInput__value">
                        {{ value }}
                    </div>

                    <button v-if="!disabled" type="button" @click="onEdit">
                        <template v-if="['text', 'date'].includes(edit_type)">
                            Zmień
                        </template>

                        <svg v-if="edit_type == 'icon'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M1.7002 4.3702V19.6302C1.7002 21.1002 2.9002 22.3002 4.3702 22.3002H19.6302C21.1002 22.3002 22.3002 21.1002 22.3002 19.6302V9.9802C22.3002 9.54019 21.9402 9.1802 21.5002 9.1802C21.0602 9.1802 20.7002 9.54019 20.7002 9.9802V19.6302C20.7002 20.2202 20.2202 20.7002 19.6302 20.7002H4.3702C3.7802 20.7002 3.3002 20.2202 3.3002 19.6302V4.3702C3.3002 3.7802 3.7802 3.3002 4.3702 3.3002H13.7002C14.1402 3.3002 14.5002 2.9402 14.5002 2.5002C14.5002 2.0602 14.1402 1.7002 13.7002 1.7002H4.3702C2.9002 1.7002 1.7002 2.9002 1.7002 4.3702Z" fill="#B1B1B1"/>
                            <path d="M10.3504 15.2901C9.94043 15.7001 9.39043 15.9301 8.82043 15.9301L7.31043 15.9501C6.84043 15.9501 6.39043 16.1401 6.06043 16.4701L5.11043 17.4201C4.80043 17.7301 4.80043 18.2401 5.11043 18.5501C5.27043 18.7101 5.47043 18.7801 5.68043 18.7801C5.89043 18.7801 6.09043 18.7001 6.25043 18.5501L7.20043 17.6001C7.20043 17.6001 7.28043 17.5501 7.33043 17.5501L8.84043 17.5301C9.84043 17.5301 10.7804 17.1301 11.4904 16.4201L19.3204 8.59008L21.5604 6.35008C21.8604 6.05008 22.0304 5.64008 22.0304 5.22008C22.0304 4.80008 21.8604 4.39008 21.5604 4.08008L19.6404 2.17008C19.0204 1.55008 18.0004 1.55008 17.3804 2.17008L15.0404 4.51008L7.29043 12.2601C6.69043 12.8601 6.31043 13.6501 6.21043 14.4801C6.16043 14.9201 6.47043 15.3201 6.91043 15.3701C6.94043 15.3701 6.98043 15.3701 7.01043 15.3701C7.41043 15.3701 7.75043 15.0701 7.80043 14.6701C7.86043 14.1901 8.08043 13.7301 8.43043 13.3801L15.7104 6.10008L17.6304 8.02008L10.3704 15.2801L10.3504 15.2901ZM18.5004 3.30008L20.4204 5.22008L18.7504 6.89008L16.8304 4.97008L18.5004 3.30008Z" fill="#B1B1B1"/>
                        </svg>
                    </button>
                </template>

                <template v-if="edit">
                    <template v-if="items">
                        <InputSelect v-model="ivalue" :items="items" :hint="hint" :required="true" :error="error" @update:modelValue="$emit('update:innerValue', $event)" />
                    </template>

                    <template v-else>
                        <InputDate v-if="type == 'date'" :modelValue="ivalue" :min="date_min" :onlyfirsts="date_onlyfirsts" :required="true" :error="error" @update:modelValue="onUpdateDate" />
                        <InputText v-else type="text" v-model="ivalue" :unit="unit" :required="true" :error="error" @update:modelValue="$emit('update:innerValue', $event)" />
                    </template>

                    <button type="button" @click="onAccept" :disabled="error != null">Zapisz</button>
                </template>
            </div>

            <template v-if="edit">
                <slot name="edit_footer"></slot>
            </template>
        </div>
    `,

    emits: [
        'tip',
        'update:modelValue',
        'update:innerValue',
    ],

    props: {
        label: { type: String },
        hint: { type: String },
        unit: { type: String },
        type: { type: String },
        modelValue: {},
        error: {},
        items: {},

        date_min: { type: [Date, String] },
        date_onlyfirsts: { type: Boolean },

        disabled: { type: Boolean, default: false },

        edit_type: { type: String, default: 'text' },

        tip: { type: Boolean, default: false },
    },

    computed: {
        value() {
            if (this.ivalue) {
                switch (this.type) {
                    case 'list':
                        const i = this.items.filter(v => v.id == this.ivalue);

                        if (i?.length) {
                            return i[0].label;
                        }

                        return '-';

                    case 'month':
                        return Utils.monthsTitle(this.ivalue);

                    case 'kwh':
                        return this.ivalue + ' ' + this.unit;

                    case 'date':
                        if (!this.ivalue) {
                            return null;
                        }

                        const m = moment(this.ivalue);

                        return m.format('DD.MM.YYYY');

                    default:
                        return this.ivalue;
                }
            } else {
                return this.hint;
            }
        },
    },

    watch: {
        modelValue() {
            this.ivalue = this.modelValue;
        },
    },

    methods: {
        onEdit() {
            this.edit = true;
            this.ivalue = this.modelValue;
        },

        onAccept() {
            this.edit = false;

            this.$emit('update:modelValue', this.ivalue);
        },
    },

    setup(props, ctx) {
        const edit = ref(false);
        const ivalue = ref(props.modelValue);

        function onUpdateDate(val: Date) {
            ivalue.value = val;

            ctx.emit('update:innerValue', val);
        }

        return {
            edit,
            ivalue,

            onUpdateDate,
        }
    },
});
